import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const Title: React.SFC<IProps> = props => (
  <Container style={props.style} className={props.className}>
    {props.children}
  </Container>
);

const Container = styled.h3`
  font-size: 35px;
  font-weight: bold;
  text-transform: uppercase;
  @media (max-width: 900px) {
    font-size: 25px;
  }
`;

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title/Title.tsx